interface IIcon {
  width?: string;
  color?: string;
  height?: string;
}
const FilesIcon = ({ width = '16', color = '#AAAAAA', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.81836 0.96875H9.91877L9.0873 0.137313C8.99942 0.049375 8.8802 0 8.75586 0H3.91211C3.22286 0 2.66211 0.56075 2.66211 1.25V10.9375C2.66211 11.53 3.07667 12.0272 3.63086 12.1552V3.15625C3.63086 1.95006 4.61214 0.96875 5.81836 0.96875Z"
      fill={color}
      fillOpacity="0.5"
    />
    <path
      d="M7.72461 2.875H11.825L10.9936 2.04356C10.9057 1.95562 10.7865 1.90625 10.6621 1.90625H5.81836C5.12911 1.90625 4.56836 2.467 4.56836 3.15625V12.8438C4.56836 13.4362 4.98292 13.9335 5.53711 14.0614V5.0625C5.53711 3.85628 6.51839 2.875 7.72461 2.875Z"
      fill={color}
      fillOpacity="0.5"
    />
    <path
      d="M12.5684 7.25C12.3095 7.25 12.0996 7.04012 12.0996 6.78125V3.8125H7.72461C7.03536 3.8125 6.47461 4.37325 6.47461 5.0625V14.75C6.47461 15.4392 7.03536 16 7.72461 16H14.2871C14.9764 16 15.5371 15.4392 15.5371 14.75V7.25H12.5684ZM13.1934 12.875H8.81836C8.55948 12.875 8.34961 12.6651 8.34961 12.4062C8.34961 12.1474 8.55948 11.9375 8.81836 11.9375H13.1934C13.4522 11.9375 13.6621 12.1474 13.6621 12.4062C13.6621 12.6651 13.4522 12.875 13.1934 12.875ZM13.1934 11H8.81836C8.55948 11 8.34961 10.7901 8.34961 10.5312C8.34961 10.2724 8.55948 10.0625 8.81836 10.0625H13.1934C13.4522 10.0625 13.6621 10.2724 13.6621 10.5312C13.6621 10.7901 13.4522 11 13.1934 11ZM13.1934 9.125H8.81836C8.55948 9.125 8.34961 8.91512 8.34961 8.65625C8.34961 8.39738 8.55948 8.1875 8.81836 8.1875H13.1934C13.4522 8.1875 13.6621 8.39738 13.6621 8.65625C13.6621 8.91512 13.4522 9.125 13.1934 9.125Z"
      fill={color}
      fillOpacity="0.5"
    />
    <path d="M13.0371 4.08691V6.31232H15.2625L13.0371 4.08691Z" fill={color} fillOpacity="0.5" />
  </svg>
);

export default FilesIcon;
